
  export const style={
    inpuStyle:{
      colorInput:"#12122E"
    },
    url:{
      urlClient:"https://wco.prd.appnoz.com.br/",
      urlClientYouseed:"https://admyouseed.bancosemear.com.br/"
    },
    fileUrl:{
      logo:"https://storage-client-profile.appnoz.com.br/base-api/uploads/logos/profile_client/logoclient/118/WCO_Preto__1_.png",
      secondaryLogonLogo: "null",
    },
    variables:{
       customMenuItem: true,
       autoRegister: false,
       recaptchaVersion : "V2"
    },
    CurrencyName:{
      name:"Card/Cards"
    },
    teamName:{
      name:"wco"
    },
    hasToken: true,
    hostHeader: "wco"
  }
